import { State } from "../interfaces";

export const isSupermanager = (state: State) =>
  Boolean(state.auth.user?.role?.includes("supermanager"));
